import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
	LINK: '[data-fragment="ShowBlockOnHoverComponent.link"]',
	BLOCK: '[data-fragment="ShowBlockOnHoverComponent.block"]',
	ITEM: '[data-fragment="ShowBlockOnHoverComponent.item"]',
};

class ShowBlockOnHoverComponent extends WebComponent {
	constructor(props) {
		super(props);
		const {
			show = false,
		} = props;
		this.state = {
			show,
		};
	}
	didMount() {
		this.on('click', fragments.LINK, this.handleClickOnLink);
		this.on('mouseover',fragments.LINK, this.handleShowBlock);
		this.on('mouseout',fragments.LINK, this.handleHideBlock);
		this.block = this.element.querySelector(fragments.BLOCK);
		this.itemElement = this.element.querySelectorAll(fragments.ITEM);
	}

	handleClickOnLink = (e) => {
		const {
			show,
		} = this.state;
		e.preventDefault();
		this.block.style = '';
		if(!this.block.classList.contains('show')) {
			classNames(this.block, {'show': true});
		} else {
			classNames(this.block, {'show': false});
		}
		classNames(document.getElementById(e.target.hash.replace('#','')), {'show': show});
	}

	handleShowBlock = (e) => {
		const {
		} = this.state;
		this.setState({
		});
		e.preventDefault();
		var hash = e.target.hash;
		var idd = hash.replace('#','');
		if(document.getElementById(idd).style.display === "none"){
			this.block.classList.remove('show');
		}

		if(!this.block.classList.contains('show')){
			for(let i = 0; i < this.itemElement.length; i++) {
				let content = this.itemElement[i];
				content.style.display = "none";
			}
			document.getElementById(idd).style.display = 'inline-block';
			this.block.style.display = 'inline-block';
		}
	}

	handleHideBlock = (e) => {
		const {
		} = this.state;
		this.setState({
		});
		e.preventDefault();
		if(!this.block.classList.contains('show')){
			for(let i = 0; i < this.itemElement.length; i++) {
				let content = this.itemElement[i];
				content.classList.remove('show');
				content.style.display = "none";
			}
			this.block.style.display = 'none';
		}
	}

	willUnMount() {
		this.list = null;
		this.block = null;
		this.item = null;
	}
	update(prevProps, prevState, inDocument) {
		const {
			show,
		} = this.state;
	}
}

export default ShowBlockOnHoverComponent;




// WEBPACK FOOTER //
// ./fe/web-career/src/js/components/ShowBlockOnHoverComponent/ShowBlockOnHoverComponent.js